<ng-container *ngFor="let primaryNavItem of primaryNavItems">
  <ul *ngIf="primaryNavItem.url || primaryNavItem.childList?.length">
    <li *ngIf="primaryNavItem.url">
      <a [href]="primaryNavItem.url">{{ primaryNavItem.title }}</a>
    </li>
    <li *ngIf="primaryNavItem.childList?.length">
      <ng-container *ngFor="let secondaryNavGroup of primaryNavItem.childList">
        <ul *ngIf="secondaryNavGroup.childList?.length">
          <ng-container *ngFor="let secondaryNavItem of secondaryNavGroup.childList">
            <li *ngIf="secondaryNavItem.url">
              <a [href]="secondaryNavItem.url">{{ secondaryNavItem.headline || secondaryNavItem.title }}</a>
            </li>
          </ng-container>
        </ul>
      </ng-container>
    </li>
  </ul>
</ng-container>
